import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addUtmParameters } from '../../../redux/slices/utmSlice';
import PropTypes from 'prop-types';

const Utms = ({ fields }) => {
  let dispatch = useDispatch();

  useEffect(() => {
    let searchParams = new URLSearchParams(
      typeof window !== 'undefined' ? window.location.search : ''
    );
    let utmParameters = {};
    let updateUtms = false;
    if (!fields.utmParamNames?.value?.length) {
      return;
    }

    for (const utmParamName of fields.utmParamNames.value.split(/\r?\n/)) {
      const paramName = utmParamName.replace(/utm_/g, '');
      const value = searchParams.get(`utm_${paramName}`);
      if (value) {
        updateUtms = true;
        utmParameters[paramName] = value;
      }
    }

    if (updateUtms) {
      dispatch(addUtmParameters(utmParameters));
    }
  }, []);

  return <></>;
};

Utms.propTypes = {
  fields: PropTypes.shape({
    utmParamNames: PropTypes.shape({
      value: PropTypes.string,
    }),
  }).isRequired,
};

export default Utms;
